/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC1155, ERC1155Interface } from "../ERC1155";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC1155ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC1155ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC1155__factory extends ContractFactory {
  constructor(...args: ERC1155ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC1155> {
    return super.deploy(uri_, overrides || {}) as Promise<ERC1155>;
  }
  getDeployTransaction(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(uri_, overrides || {});
  }
  attach(address: string): ERC1155 {
    return super.attach(address) as ERC1155;
  }
  connect(signer: Signer): ERC1155__factory {
    return super.connect(signer) as ERC1155__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC1155Interface {
    return new utils.Interface(_abi) as ERC1155Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155 {
    return new Contract(address, _abi, signerOrProvider) as ERC1155;
  }
}
